/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC1155, ERC1155Interface } from "../ERC1155";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC1155ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC1155ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC1155__factory extends ContractFactory {
  constructor(...args: ERC1155ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC1155> {
    return super.deploy(uri_, overrides || {}) as Promise<ERC1155>;
  }
  getDeployTransaction(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(uri_, overrides || {});
  }
  attach(address: string): ERC1155 {
    return super.attach(address) as ERC1155;
  }
  connect(signer: Signer): ERC1155__factory {
    return super.connect(signer) as ERC1155__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC1155Interface {
    return new utils.Interface(_abi) as ERC1155Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155 {
    return new Contract(address, _abi, signerOrProvider) as ERC1155;
  }
}
